import { PatientId, WithPatientId } from '../surgicalEvent.slice';
import { doctorBffApi } from '@/modules';
import { AllergyService } from './allergy.service';
import { Allergy } from './allergy.model';
import { wrapError } from '../../error';
import { ID } from '@ianesthesie-kit/services';

export const allergyApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    allergies: builder.query<Allergy[], PatientId>({
      queryFn: ({ patientId }) =>
        AllergyService.getInstance(patientId).fetch().catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'Allergy', id: patientId }
      ]
    }),

    addAllergy: builder.mutation<
      Allergy[],
      WithPatientId<{ allergy: Partial<Allergy> }>
    >({
      queryFn: ({ patientId, allergy }) =>
        AllergyService.getInstance(patientId).create(allergy).catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        'Dashboard',
        { type: 'Allergy', id: patientId }
      ]
    }),

    replaceAllergies: builder.mutation<
      Allergy[],
      WithPatientId<{ allergies: Partial<Allergy>[] }>
    >({
      queryFn: ({ patientId, allergies }) =>
        AllergyService.getInstance(patientId)
          .replace(allergies)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        'Dashboard',
        { type: 'Allergy', id: patientId }
      ]
    }),

    deleteAllergy: builder.mutation<Allergy[], WithPatientId<ID, 'allergyId'>>({
      queryFn: ({ patientId, allergyId }) =>
        AllergyService.getInstance(patientId)
          .delete(allergyId)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        'Dashboard',
        { type: 'Allergy', id: patientId }
      ]
    })
  }),
  overrideExisting: false
});

export const {
  useAllergiesQuery,
  useAddAllergyMutation,
  useReplaceAllergiesMutation,
  useDeleteAllergyMutation
} = allergyApi;
